
<template lang="pug">
component(
  v-on="$listeners"
  :disabled="disabled"
  :is="htmlTag"
  :class="buttonClass"
  :aria-label="label")
  slot {{ label }}
</template>

<script>
  export default {
    name: 'VButton',
    props: {
      label: String,
      disabled: Boolean,
      htmlTag: {
        type: String,
        default: 'button',
      },
      primary: {
        type: Boolean,
        default: false,
      },
      primary_alt: {
        type: Boolean,
        default: false,
      },
      secondary: {
        type: Boolean,
        default: false,
      },
      secondary_alt: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      buttonClass () {
        return {
          'btn btn--primary btn--icon': this.primary === true,
          'btn btn--primary-alternate btn--icon': this.primary_alt === true,
          'btn btn--secondary btn--icon': this.secondary === true,
          'btn btn--secondary-alternate btn--icon': this.secondary_alt === true
        }
      }
    }
  }
</script>
